"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bannerClick = void 0;
var bannerClick = function (event) {
    var _a, _b, _c, _d;
    return {
        event: 'banner',
        eventInfo: 'banner',
        action: 'banner',
        banner: {
            bannerName: (_b = (_a = event.eventData) === null || _a === void 0 ? void 0 : _a.banner) === null || _b === void 0 ? void 0 : _b.bannerName,
            bannerCTA: (_d = (_c = event.eventData) === null || _c === void 0 ? void 0 : _c.banner) === null || _d === void 0 ? void 0 : _d.bannerCTA
        }
    };
};
exports.bannerClick = bannerClick;
